import React from "react";
import { FacilityOrderTemplateNewFlowPatientCreateTemplate } from "themes/application/facility-order-new-flow/pages";
import { observer } from "mobx-react";
import { FacilityOrderTemplateNewFlowPatientCreateViewStore } from "application/facility-order-new-flow/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderTemplateNewFlowPatientCreateViewStore(rootStore), "facilityOrderTemplateNewFlowPatientCreateViewStore")
@observer
class FacilityOrderTemplateNewFlowPatientCreate extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowPatientCreateTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowPatientCreate;